import AppIcon from '@/components/AppIcon.tsx';
import { IconType } from 'react-icons';
import { CustomSVG } from '@/types/common.ts';
import { Flex, FlexProps, Image } from '@mantine/core';
import { INTEGRATION_LOGO_BASE_PATH } from '@/utils/constants.ts';
import React from 'react';
import { HiOutlineEnvelope, HiRss } from 'react-icons/hi2';
import { LuWebhook } from 'react-icons/lu';

import { IntegrationProvider } from '@/types/integrations.ts';
import {
  isStandaloneCapabilityProvider,
  isSystemIntegrationProvider,
} from '@/utils/providerKinds.ts';

type props = FlexProps & {
  Icon?: IconType;
  CustomIcon?: CustomSVG;
  bg: string;
  iconColor: string;
  size?: number;
  integrationName?: string;
  integrationProvider?: IntegrationProvider;
};

const StepCardIcon = ({
  Icon,
  CustomIcon,
  bg,
  iconColor,
  size = 34,
  integrationProvider,
  style,
  ...props
}: props) => {
  let logo = null;
  if (integrationProvider) {
    const integrationName = integrationProvider.name;
    if (isStandaloneCapabilityProvider(integrationProvider)) {
      logo = null;
    } else if (isSystemIntegrationProvider(integrationProvider)) {
      let icon: IconType | null = null;
      if (integrationName === 'email') {
        icon = HiOutlineEnvelope;
      } else if (integrationName === 'webhook') {
        icon = LuWebhook;
      } else if (integrationName === 'http-request') {
        icon = HiRss;
      }
      if (icon) {
        const iconSize = size * 0.35;
        logo = (
          <Flex p={'2px'}>
            <AppIcon Icon={icon} size={iconSize} />
          </Flex>
        );
      }
    } else {
      const logoURL = `${INTEGRATION_LOGO_BASE_PATH}${integrationName.toLowerCase().replace('-', '_')}.svg`;
      logo = (
        <Flex p={'3px'}>
          <Image src={logoURL} height={'10px'} fit={'contain'} w={'unset'} />
        </Flex>
      );
    }
  }

  return (
    <span
      style={{ position: 'relative', display: 'flex', marginTop: 'auto', marginBottom: 'auto' }}
    >
      <AppIcon
        Icon={Icon}
        CustomIcon={CustomIcon}
        size={size * 0.7}
        bg={bg}
        w={size}
        h={size}
        iconProps={{ color: iconColor, strokeWidth: '1.3px' }}
        style={{
          borderRadius: 6,
          color: iconColor,
          boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.04), 0 3px 6px -2px rgba(0, 0, 0, 0.02)',
          ...style,
        }}
        {...props}
      />
      {logo && (
        <Flex
          style={{
            position: 'absolute',
            bottom: '-4px',
            right: '-4px',
            background: 'white',
            borderRadius: '6px',
            border: '1px solid #ececed',
          }}
        >
          {logo}
        </Flex>
      )}
    </span>
  );
};

export default StepCardIcon;
